import { useState, useEffect } from "react";
import { useRef } from "react";
import { useCallback } from "react";
import { useMemo } from "react";
import { debounce } from "lodash";
import { LinearProgress } from "@mui/material";

import Footer from "@/Components/common/footer";
import NotesSectionDashboard from "@/Components/NotesSectionDashboard/main";
import { fetchPageObject, getCaseId } from "@/Utils/helper";
import Sidebar from "@/Components/Sidebars/main";
import NavBar from "@/Components/Navbars/main";
import ActionBarComponent from "@/Components/common/ActionBarComponent";
import SimpleIcon from "@/assets/images/simple-icon.svg";
import DetailIcon from "@/assets/images/detail.svg";
import DatesIcon from "@/assets/images/dates.svg";
import SmartResponsiveTabsContainer from "@/Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";

import useLibraryDocuments from "../hooks/useLibraryDocuments";
import LibraryDocumentTab from "../components/LibraryDocumentViewer/library-document-tab";
import LibraryUpdatedTab from "../components/LibraryDocumentViewer/library-detailed-tab";
import LibrarySummaryTab from "../components/LibraryDocumentViewer/librarySummaryTab";
const LibraryPage = () => {
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 15).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const containerHeight = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const { documents, loading, refetch } = useLibraryDocuments({
    search: "",
    tag: null,
    pageNo: pageNo,
    pageSize: 25,
  });

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        refetch({ search: value });
      }, 500),
    []
  );
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState("summary");
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleInputChange = useCallback(
    (event) => {
      const value = event.target.value;
      setSearchTerm(value);
      setQuery(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );
  const tabsData = [
    {
      id: "summary",
      label: "Summary",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      onClick: () => {
        setPageNo(1);
        handlePageChange("summary");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DatesIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "simple",
      label: "Simple",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",

      onClick: () => {
        setPageNo(1);
        handlePageChange("simple");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={SimpleIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "detailed",
      label: "Detailed",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",

      onClick: () => {
        setPageNo(1);
        handlePageChange("detailed");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DetailIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
  ];
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"81"} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar" ref={containerHeight}>
            <div className="d-flex align-items-center m-b-5 p-r-5 w-100 height-25 ps-0">
              <textarea
                className=" height-25 m-0 note_assign_text note_assign_text-new"
                // className="note_assign_text slanted-textarea"
                style={{
                  padding: "0px 10px",
                  resize: "none",
                  width: "100%",
                  height: "25px",
                  border: "2px solid var(--primary-25)",
                }}
                placeholder="Type three or more characters to search library documents on the case..."
                value={searchTerm}
                onChange={handleInputChange}
              />
            </div>

            <SmartResponsiveTabsContainer
              HandlePage={currentPage}
              tabsData={[]}
              viewTab={tabsData}
              addTab={[]}
              photoTab={[]}
              handlePageChange={handlePageChange}
              viewType={currentPage}
            />
            <div
              style={{
                width: "100%",
                justifyContent: "flex-start",
                background: "var(--primary)",
                height: "25px",
                marginBottom: "5px",
                position: "relative",
              }}
            >
              <span
                className="fw-bold text-white"
                style={{
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textTransform: "capitalize",
                }}
              >
                {currentPage} View
              </span>
            </div>

            {loading ? (
              <>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress key={loading} color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
              </>
            ) : currentPage === "simple" ? (
              <>
                <LibraryDocumentTab
                  data={documents}
                  refetchData={() => {
                    refetch({ search: query });
                  }}
                />
              </>
            ) : currentPage === "detailed" ? (
              <>
                <LibraryUpdatedTab
                  data={documents}
                  refetchData={() => {
                    refetch({ search: query });
                  }}
                />
              </>
            ) : (
              <>
                <LibrarySummaryTab
                  doc={documents}
                  containerHeight={containerHeight}
                  refetchData={() => {
                    refetch({ search: query });
                  }}
                />
              </>
            )}

            <NotesSectionDashboard pageName={"Library"} pageObj={pageObject} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default LibraryPage;
